<template>
  <ClicColInterno 
    :cp="cp" :key="componentKey"
  >
    <b-img 
      :alt="alt" 
      :blank="blank" 
      :blank-color="blankColor" 
      :block="block" 
      :center="center" 
      :fluid="fluid"
      :fluid-grow="fluidGrow" 
      :height="height" 
      :left="left" 
      :right="right" 
      :rounded="rounded" 
      :sizes="sizes"
      :src="src ? src : fallbackSrc ? fallbackSrc : ''" 
      :srcset="srcset" 
      :thumbnail="thumbnail" 
      :width="width"
      :style="[{ cursor: hasClickEvent ? 'pointer' : 'default' }, style]" 
      :class="this.class" 
      :title="title" 
      @error="handleImageError"
      @click="click"
    >
    </b-img>
  </ClicColInterno>
</template>

<script>
import ComponentMixin from '../../core/ComponentMixin';
import { BImg } from 'bootstrap-vue';

export default {
  name: 'ClicImage',
  mixins: [ComponentMixin],
  components: { BImg },
  methods: {

    handleImageError(event) {
      if (this.fallbackSrc) {
        event.target.src = this.fallbackSrc
      }else{
        try{
          event.target.src = "https://storage.googleapis.com/cv-pub-cloud/_assets/images/withoutImage.jpg"
        }catch(error){
          console.error(`ClicImage -> não foi possível atribuir o valor ao parâmetro fallbackSrc`)
        }
      }
    },

    click(event) {
      if  (this.lodash.has(this.cp, 'events.click')) {
        this._execEvent('click', { event });
      } 
    }

  },

  computed: {
    hasClickEvent() {
      return this?.cp?.events?.click;
    }
  },

};
</script>
